import { render, staticRenderFns } from "./day-by-day-educator.vue?vue&type=template&id=1463b858&scoped=true&"
import script from "./day-by-day-educator.vue?vue&type=script&lang=js&"
export * from "./day-by-day-educator.vue?vue&type=script&lang=js&"
import style0 from "./day-by-day-educator.vue?vue&type=style&index=0&id=1463b858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463b858",
  null
  
)

export default component.exports